import React from "react";
import { Toaster } from "react-hot-toast";

export const ToastProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      {children}
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 4000,
          className: "animate-enter-custom",
        }}
      />
    </>
  );
};
